import React, { useState } from 'react';


import logoImage from '../../../images/three-sixty-image/AvanadeLogo.png';

import { threeSixtyData } from "../components/360Wheel/ThreeSixtyDataCopilot";





import '../../Sales/Home.scss';

import './Page.scss';



import { Ws360Wheel } from "../components/360Wheel/360Wheel";
import { WsWheelItem, WsWheelRecharts } from "./WheelRecharts";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { Shimmer } from "office-ui-fabric-react";





const data: WsWheelItem[] = [
  { name: 'Adoption',              value: 100 },
  { name: 'Usage',                 value: 100 },
  { name: 'Readiness',             value: 100 },
  { name: 'Impact',                value: 100 },
  { name: 'Financial',             value: 100 },
  { name: 'Training and\nSupport', value: 100 },
  // { name: 'Productivity\nImpact',  value: 100 },
  // { name: 'Productivity',          value: 100 },
  // { name: 'User\nSatisfaction',    value: 100 },
  // { name: 'Error\nReduction',      value: 100 },
  // { name: 'Training and\nSupport', value: 100 },
  // { name: 'Financial',             value: 100 }
];




const dataLevel2: WsWheelItem[][] = [

  [
    { name: 'Groups',   value: 100 },
    { name: 'Apps',     value: 100 },
    { name: 'Features', value: 100 }
  ],

  [
    { name: 'Groups',   value: 100 },
    { name: 'Apps',     value: 100 },
    { name: 'Features', value: 100 }
  ],

  [
    { name: 'Infrastructure', value: 100 },
    { name : 'Data',          value: 100 },
    { name: 'Integration',    value: 100 }
  ],

  [
    { name: 'Teams\nChat',       value: 100 },
    { name: 'Teams\nMeeting',    value: 100 },
    { name: 'Mail',              value: 100 },
    { name: 'Copilot\nChat',     value: 100 },
    { name: 'Document\nRelated', value: 100 }
  ],

  [
    { name: 'Licensing',   value: 100 },
    { name: 'Cost Saving', value: 100 }
  ],

  [
    { name: 'Training\nSessions\nConducted', value: 100 },
    { name: 'Support\nResponse\nTime',       value: 100 }
  ]

];



const isActive = (pathname: string, path: string, startsWith?: boolean) => {
  if (startsWith) {
    return pathname.toLowerCase().indexOf(path) === 0;
  } else {
    return pathname === path;
  }
};


const WsCopilotPage = (props: any) => {

  const history = useHistory();
  const currentLocation = useLocation();

  // const [ tab, setTab ] = useState<string>('dashboard');

  return (
    <div className="ws-deliver-page">

      <div className="ws-deliver-page-header">

        <div className="tabs is-medium is-boxed">
          <ul>
            <li className="ws-deliver-decode-page-title">
              <h1>
                Copilot
              </h1>
            </li>
            <li className={ isActive(currentLocation.pathname, '/deliver/copilot',               false) ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/copilot')               }}>Dashboard</a></li>
            <li className={ isActive(currentLocation.pathname, '/deliver/copilot/triage',        false) ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/copilot/triage')        }}>Triage</a></li>
            <li className={ isActive(currentLocation.pathname, '/deliver/copilot/value-tracker', false) ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/copilot/value-tracker') }}>Value Tracker</a></li>
            <li className={ isActive(currentLocation.pathname, '/deliver/copilot/service',       false) ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/copilot/service')       }}>Service</a></li>
            <li className={ isActive(currentLocation.pathname, '/deliver/copilot/admin',         true)  ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/copilot/admin')         }}>Admin</a></li>
          </ul>
        </div>

      </div>

      <Route path="/deliver/copilot/admin">
        <div className="ws-deliver-page-menu">
          <a className={ isActive(currentLocation.pathname, '/deliver/copilot/admin',              false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push('/deliver/copilot/admin')              }}>Data Sources</a>
          <a className={ isActive(currentLocation.pathname, '/deliver/copilot/admin/metrics',      false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push('/deliver/copilot/admin/metrics')      }}>Metrics</a>
          <a className={ isActive(currentLocation.pathname, '/deliver/copilot/admin/data-browser', false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push('/deliver/copilot/admin/data-browser') }}>Data Browser</a>
          <a className={ isActive(currentLocation.pathname, '/deliver/copilot/admin/profiles',     false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push('/deliver/copilot/admin/profiles')     }}>Profiles</a>
          <a className={ isActive(currentLocation.pathname, '/deliver/copilot/admin/actions',      false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push('/deliver/copilot/admin/actions')      }}>Actions</a>
        </div>
      </Route>

      <Switch>

        <Route exact path="/deliver/copilot">
          <div>
            <WsWheelRecharts
              data={data}
              dataLevel2={dataLevel2}
              overallScore={50}
            />
          </div>
        </Route>

        <Route>
          <br />
          <Shimmer />
          <br />
          <Shimmer width="80%" />
          <br />
          <Shimmer width="60%" />
          <br />
          <Shimmer width="40%" />
          <br />
          <br />
          <br />
        </Route>

      </Switch>

      {/* <div className="ws-deliver-page-menu">
        <a className="ws-deliver-page-menu-item" href="">Dashboard</a>
        <a className="ws-deliver-page-menu-item" href="">Value Metrics</a>
      </div> */}

      {/* <div>
        <WsWheelRecharts
          data={data}
          dataLevel2={dataLevel2}
        />
      </div> */}

      {/* <Ws360Wheel
        threeSixtyData={threeSixtyData}
        imageLogo={logoImage}
        borderColour={'#dc4600'}
        title="Copilot"
      /> */}

    </div>
  );
};

export { WsCopilotPage };
